import React, { useContext } from 'react';
import { MapContext } from '../../../../../contexts/MapContext';
import './Loader.scss';

const MarkersPathLoader = () => {
    const { markersPathStatus } = useContext(MapContext);

    return (
        <div className={`map-loader-overlay ${markersPathStatus === 'loading' ? 'visible' : ''}`}>
            <div className="map-spinner" />
        </div>
    );
};

export default MarkersPathLoader;
